module.exports = __webpack_public_path__ + "static/media/image-card-1.5048e036.png";